/**
 * The integrator's allowed_domain_redirect_patterns are signed into the Plaid
 * state token at flow start (inside the iframe, where SettingsProvider is
 * populated). PlaidMain verifies that token and caches the patterns here so they
 * survive the fullpage OAuth bounce to the redirect handlers (which run on the
 * /ui/plaid/* route where SettingsProvider is NOT populated).
 *
 * Security note: this is a transport cache, not the trust boundary. The patterns'
 * integrity is anchored by the server-side JWT signature (verifyToken), not by
 * sessionStorage. An attacker able to rewrite sessionStorage already has script
 * execution in this origin and could redirect directly, so caching here adds no
 * additional attack surface.
 */
const STORAGE_KEY = "tilia.ac.allowed-redirect-patterns";

export const storeAllowedRedirectPatterns = (patterns) => {
  // store even when undefined/null so a fresh flow does not inherit a stale value
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(patterns ?? null));
};

export const getAllowedRedirectPatterns = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || undefined;
  } catch {
    return undefined;
  }
};
